import { TrackableEntity } from "./ChangeTrackable";

export abstract class TrackableEntityWithCntrTrack extends TrackableEntity {
    trStatus: string = '';
    trType: string = '';
    trDate: string | null = null;
    trBy: string = '';
    trStatusDesc: string = '';
    lastEventDate: string | null = null;
    lastEvent: string = '';

    constructor() {
        super();
        this.noTrackProps.push('trType', 'trDate', 'trStatus', 'trStatusDesc',
            'lastEventDate', 'lastEvent', 'trBy'
        );
    }
}